<template>
    <div id="news-item">
      <div v-for="(item,index) in newsInfo" :key="index" style="width: 96%;margin: 0 auto;margin-top: 20px">
        <van-row style="margin-top: 20px" @click="jumpTo(item.id,item.externalUrl)">
          <van-col :span="10">
            <img class="news-cover" :src="item.cover" />
          </van-col>
          <van-col :span="14">
            <div class="news-title">{{item.title}}</div>
            <div class="news-summary">{{item.summary}}</div>
            <div class="news-createTime">{{item.createTime}}</div>
          </van-col>
        </van-row>
      </div>
    </div>
</template>

<script>
export default {
  name: 'NewsItem',
  props: ['newsInfo'],
  methods: {
    jumpTo (id, externalUrl) {
      if (externalUrl === null || externalUrl.length === 0) {
        this.$router.push({ name: 'InfomationDetail', query: { id } });
      } else {
        window.location.href = externalUrl;
      }

    }
  }
};
</script>

<style scoped>
.news-cover{
  border-radius: 10px;
  width: 90%;
  box-shadow: 3px 3px 5px #CCCCCC;
}
.news-title{
  overflow: hidden;
  white-space: nowrap;
  text-overflow:ellipsis;
  font-size: 32px;
  font-weight: bolder;
  text-align: left;
  line-height: 60px;
}
  .news-summary{
    font-size: 28px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    color: #999999;
    height: 1rem;
  }
  .news-createTime{
    font-size: 26px;
    color: #999aaa;
  }
</style>